<div class="contact-page">

  <!-- Hero -->
  <div class="contact-hero">
    <div class="contact-hero__bg"></div>
    <div class="contact-hero__content">
      <a routerLink="/" class="contact-hero__back">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M19 12H5M5 12l7-7M5 12l7 7"/>
        </svg>
        Retour à l'accueil
      </a>
      <div class="contact-hero__badge">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
        Support & Contact
      </div>
      <h1 class="contact-hero__title">Comment pouvons-nous<br><span class="contact-hero__title--accent">vous aider ?</span></h1>
      <p class="contact-hero__subtitle">Notre équipe est disponible pour répondre à toutes vos questions. Nous vous répondons sous 24 à 48h ouvrables.</p>
    </div>
  </div>

  <!-- Main grid -->
  <div class="contact-main">

    <!-- Left: form + email -->
    <div class="contact-left">

      <!-- Email card -->
      <a [href]="'mailto:' + contactEmail" class="contact-email-card">
        <div class="contact-email-card__icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
        </div>
        <div class="contact-email-card__text">
          <span class="contact-email-card__label">Écrire directement</span>
          <span class="contact-email-card__value">{{ contactEmail }}</span>
        </div>
        <svg class="contact-email-card__arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </a>

      <!-- Form card -->
      <div class="contact-form-card">
        <h2 class="contact-form-card__title">Envoyer un message</h2>
        <p class="contact-form-card__subtitle">Remplissez le formulaire et nous vous répondrons rapidement.</p>

        <!-- Success -->
        <div *ngIf="submitStatus === 'success'" class="contact-alert contact-alert--success">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14M22 4 12 14.01l-3-3"/>
          </svg>
          Message envoyé ! Nous vous répondrons dans les 24-48h ouvrables.
        </div>

        <!-- Error -->
        <div *ngIf="submitStatus === 'error'" class="contact-alert contact-alert--error">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Une erreur est survenue. Veuillez réessayer ou nous écrire directement par email.
        </div>

        <div class="contact-form" *ngIf="submitStatus !== 'success'">
          <!-- Name + Email -->
          <div class="contact-form__row">
            <div class="contact-form__field">
              <label class="contact-form__label" for="name">Nom complet <span>*</span></label>
              <input
                id="name"
                class="contact-form__input"
                type="text"
                placeholder=""
                [(ngModel)]="form.name"
                required />
            </div>
            <div class="contact-form__field">
              <label class="contact-form__label" for="email">Email <span>*</span></label>
              <input
                id="email"
                class="contact-form__input"
                type="email"
                placeholder=""
                [(ngModel)]="form.email"
                required />
            </div>
          </div>

          <!-- Subject -->
          <div class="contact-form__field">
            <label class="contact-form__label" for="subject">Sujet <span>*</span></label>
            <div class="contact-form__select-wrap">
              <select
                id="subject"
                class="contact-form__select"
                [(ngModel)]="form.subject"
                required>
                <option value="" disabled selected>Choisissez un sujet…</option>
                <option *ngFor="let s of subjects" [value]="s">{{ s }}</option>
              </select>
              <svg class="contact-form__select-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M6 9l6 6 6-6"/>
              </svg>
            </div>
          </div>

          <!-- Message -->
          <div class="contact-form__field">
            <label class="contact-form__label" for="message">Message <span>*</span></label>
            <textarea
              id="message"
              class="contact-form__textarea"
              placeholder="Décrivez votre demande en détail…"
              rows="5"
              [(ngModel)]="form.message"
              required></textarea>
          </div>

          <!-- Submit -->
          <button
            class="contact-form__submit"
            (click)="onSubmit()"
            [disabled]="isLoading || !form.name || !form.email || !form.subject || !form.message">
            <span *ngIf="!isLoading">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
              </svg>
              Envoyer le message
            </span>
            <span *ngIf="isLoading" class="contact-form__spinner">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
              </svg>
              Envoi en cours…
            </span>
          </button>

          <p class="contact-form__rgpd">
            En soumettant ce formulaire, vous acceptez que vos données soient traitées conformément à notre
            <a routerLink="/politique-confidentialite">politique de confidentialité</a>.
          </p>
        </div>
      </div>
    </div>

    <!-- Right: hours + FAQ -->
    <div class="contact-right">

      <!-- Hours card -->
      <div class="contact-hours">
        <div class="contact-hours__header">
          <div class="contact-hours__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
            </svg>
          </div>
          <h3 class="contact-hours__title">Horaires de disponibilité</h3>
        </div>
        <ul class="contact-hours__list">
          <li *ngFor="let h of hours" class="contact-hours__item" [class.contact-hours__item--closed]="!h.active">
            <span class="contact-hours__day">{{ h.day }}</span>
            <span class="contact-hours__time">
              <span class="contact-hours__dot" [class.contact-hours__dot--open]="h.active"></span>
              {{ h.time }}
            </span>
          </li>
        </ul>
        <p class="contact-hours__note">Les réponses aux formulaires peuvent arriver hors de ces horaires.</p>
      </div>

      <!-- FAQ -->
      <div class="contact-faq">
        <h3 class="contact-faq__title">Questions fréquentes</h3>
        <p class="contact-faq__subtitle">Trouvez rapidement une réponse avant de nous contacter.</p>

        <div class="contact-faq__list">
          <div
            *ngFor="let faq of faqs; let i = index"
            class="contact-faq__item"
            [class.contact-faq__item--open]="faq.open">
            <button class="contact-faq__question" (click)="toggleFaq(i)">
              <span>{{ faq.question }}</span>
              <svg class="contact-faq__chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M6 9l6 6 6-6"/>
              </svg>
            </button>
            <div class="contact-faq__answer" [class.contact-faq__answer--visible]="faq.open">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>